import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ReactQueryKey } from "../../../../../../../types";

import { getLocations } from "../../../../../../../api/services";

import { FormAutocomplete } from "../../../../../../../components/fields";
import useFormTenantsDealers from "../form-tenants-dealers-hook/useFormTenantsDealers";


/**
 * Filter Form component of location
 */
const FormAutocompleteLocation = () => {
    const { t } = useTranslation('booking');
    const { tenants, dealers } = useFormTenantsDealers();

    const locationsQuery = useQuery({
        queryKey: [ReactQueryKey.Locations, { tenants, dealers }],
        queryFn: () => getLocations({ tenants, dealers }),
    });

    return (
        <FormAutocomplete<any>
            name="pickupLocations"
            label={t('label.locations')}
            options={locationsQuery.data?.locations || []}
            loading={locationsQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            multiple
        />
    );
}

export default FormAutocompleteLocation;
